export default "__VITE_ASSET__CF9ZNPdP__"